module.exports = __webpack_public_path__ + "static/media/icon_jingzhun.c73d0969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/compliance/icon_jingzhun.svg
// module id = 512
// module chunks = 0